import { Component, ViewEncapsulation } from '@angular/core';

import { AVAILABLE_LANGUAGES } from '@lib/translation';
import { TranslationService } from '@lib/translation';
import { t } from '@lib/translation/helpers';

interface LanguageOption {
  code: string;
  nativeName: string;
}

const LOCALE_KEY_MAP: Record<string, string> = {
  'en-US': 'locales.enUS',
  'en-XA': 'locales.enUS',
  'es-ES': 'locales.esES',
  'es-MX': 'locales.esMX',
  'fr-CA': 'locales.frFR',
  'fr-FR': 'locales.frFR',
  'de-DE': 'locales.deDE',
  'de-CH': 'locales.deCH',
  'en-GB': 'locales.enGB',
};

@Component({
  selector: 'fr-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class LanguageSelectorComponent {
  public readonly languages: LanguageOption[] = this._getSupportedLanguages();
  public selectedLanguage: string;

  constructor(private readonly _translationService: TranslationService) {
    this.selectedLanguage = this._getInitialLanguage();
  }

  public onLanguageChange(languageCode: string): void {
    this._translationService.setActiveLang(languageCode);
    localStorage.setItem('fusus_registry_language', languageCode);
    this.selectedLanguage = languageCode;
  }

  public getSelectedLanguageName(): string {
    const selected = this.languages.find((lang) => lang.code === this.selectedLanguage);
    return selected ? selected.nativeName : t('locales.enUS');
  }

  private _getInitialLanguage(): string {
    return this._translationService.getActiveLang() || 'en-US';
  }

  private _getSupportedLanguages(): LanguageOption[] {
    return AVAILABLE_LANGUAGES
      .filter((code) => code !== 'en-XA')
      .map((code) => ({
        code,
        nativeName: LOCALE_KEY_MAP[code] ? t(LOCALE_KEY_MAP[code] as any) : code,
      }));
  }
}
